import React from 'react';

import { Typography } from '@mui/material';
import { Checkbox } from '@infoods/lifebase-ui';

import classes from './TermsCheckbox.module.scss';

type TermsCheckboxProps = {
  check: boolean;
  setCheck: (value: boolean) => void;
};

const TermsCheckbox = ({ check, setCheck }: TermsCheckboxProps) => {
  return (
    <div className={classes.checkContainer}>
      <Checkbox
        className={classes.checkBox}
        checked={check}
        onChange={(value) => setCheck(value.target.checked)}
      />
      <Typography className={classes.checkBoxText}>I agree with </Typography>
      <Typography className={classes.checkBoxLink}>Terms of Conditions</Typography>
    </div>
  );
};

export { TermsCheckbox };
